var DeliveryModeSwitcherModel = (function (_checkoutApiModel, CheckoutSettings, PromiseUtil) {

    var DeliveryModeSwitcher = _checkoutApiModel.extend({
        defaults: {
            BasketMode: null
        },
        initialize: function (data) {
            _.bindAll(this, 'setData');
            _checkoutApiModel.prototype.initialize.apply(this, arguments);
        },
        setData: function (mode) {
            this.set('BasketMode', mode);
        },
        getMode: function () {
            return this.get('BasketMode');
        }
    });

    return DeliveryModeSwitcher.extend({
        switch: function (mode) {
            return api.switchBasketMode(mode).done(this._updateCheckout);
        }
    });
})(CheckoutApiModel, CheckoutSettings, PromiseUtil);
